import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import deliveryMenKeys from '../util/delivery-men-keys';
import {TranslatedKeys} from 'shared/types/translated-keys';
import {
  AccessControlProps,
  translatedAccessControlProps,
} from 'modules/access-controls/types';

export interface CreateDeliveryManProps extends Omit<AccessControlProps, 'id'> {
  createUser?: boolean;
}

export const translatedCreateDeliveryManProps: TranslatedKeys<CreateDeliveryManProps> =
  {
    ...translatedAccessControlProps,
    createUser: 'Criar usuário?',
  };

const useCreateDeliveryMan = () => {
  const {create} = useInfiniteQueryHelpers();

  const onSuccess = (data: AccessControlProps) =>
    create(deliveryMenKeys.list(), data);

  return useApiMutation<AccessControlProps>({
    url: '/auth/delivery-men/register',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar entregador',
    successTitle: 'Cadastrar entregador',
    successMessage: 'Entregador cadastrado com sucesso',
    redirectUrl: '/settings/delivery-men',
    onSuccess,
  });
};

export default useCreateDeliveryMan;
